<template>
  <div
    class="status"
    :class="{
      'success':isSuccess,
      'error':!isSuccess,
    }"
  >
    <slot>-----</slot>
  </div>
</template>
<script>
export default {
  name: 'Status',
  props: {
    isSuccess: {
      default: true,
      type: Boolean,
    },
  },
};
</script>
<style lang="scss" scoped>
.status {
  font-size: 14px;
  position: relative;
  padding-left: 8px;
  display: inline-block;
  &.success {
    color: $--base-color-success;
    &::before {
      background: $--base-color-success;
    }
  }
  &.error {
    color: $--base-color-error;
    &::before {
      background: $--base-color-error;
    }
  }
  &::before {
    content: '';
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }
}
</style>
